const SERVICE_NAMES = {
    'IPIPELINE': 'iPipeline',
    'UNDERWRITEME': 'UnderWriteMe',
    'IRESS': 'Iress',
};

export function serviceName(service) {
    return SERVICE_NAMES[service] || service;
}
